import {combineReducers} from 'redux'
import jobCards from './jobCards'
import confirmedOrders from './confirmedOrders'
import bulkRemoveFromJobBoardDialog from './bulkRemoveFromJobBoardDialog'
import types from 'actions/types'
import jobBoardSetup from './jobBoardSetup'
import jobCardListView from './jobCardListView'
import {unionBy} from 'lodash'



export const filters = (state = {}, action) => {
  switch (action.type) {
    case types.PRODUCTION_UPDATE_JOB_BOARD_FILTERS:
      return { ...state, ...action.filters }
    default:
      return state
  }
}

export const updateExpandedWorkCentre = (expandedWorkCentres, departmentId, workCentreId, expanded) => {
  const exists = expandedWorkCentres.some(workCentre =>
    workCentre.departmentId === departmentId && workCentre.workCentreId === workCentreId)

  return exists
    ? expandedWorkCentres.map(workCentre =>
      workCentre.departmentId === departmentId && workCentre.workCentreId === workCentreId
        ? { ...workCentre, expanded }
        : workCentre
    )
    : [
      ...expandedWorkCentres,
      { departmentId, workCentreId, expanded },
    ]
}

export const updateExpandedWorkCentres = (expandedWorkCentres, workCentres, expanded) => {
  const updatedExpandedWorkCentres = workCentres.map(workCentre => ({
    workCentreId: workCentre.id,
    departmentId: workCentre.departmentId,
    expanded,
  }))
  return unionBy(updatedExpandedWorkCentres, expandedWorkCentres, 'workCentreId')
}

export const expandedWorkCentres = (state = [], action) => {
  switch (action.type) {
    case types.PRODUCTION_EXPAND_WORK_CENTRE:
      return updateExpandedWorkCentre(state, action.departmentId, action.workCentreId, true)

    case types.PRODUCTION_COLLAPSE_WORK_CENTRE:
      return updateExpandedWorkCentre(state, action.departmentId, action.workCentreId, false)

    case types.PRODUCTION_EXPAND_WORK_CENTRES:
      return updateExpandedWorkCentres(state, action.workCentres, true)

    case types.PRODUCTION_COLLAPSE_WORK_CENTRES:
      return updateExpandedWorkCentres(state, action.workCentres, false)

    default:
      return state
  }
}

export const isJobCardViewMaximised = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_MAXIMISE_JOB_CARD_DIALOG:
      return true
    case types.PRODUCTION_RESTORE_JOB_CARD_DIALOG:
      return false
    default:
      return state
  }
}

export default combineReducers({
  jobBoardSetup,
  jobCards,
  confirmedOrders,
  filters,
  expandedWorkCentres,
  bulkRemoveFromJobBoardDialog,
  jobCardListView,
  isJobCardViewMaximised,
})
